export default "__VITE_ASSET__jMovGUq5__"